import { FileIcon } from "../file-upload";
import { useLightbox } from "./context";
import type { ItemProps } from "./shared";

export function LightboxFile({ contentType, fileName }: ItemProps) {
	/** Context */
	const lightbox = useLightbox();

	/** Render */
	return (
		<div
			className="w-max flex flex-row items-center px-4 grow-0 gap-4 relative"
			style={{
				height: lightbox.itemHeight,
				maxWidth: `calc(${lightbox.itemHeight} * 2)`,
			}}
		>
			<div className="shrink-0">
				<FileIcon fileType={contentType} />
			</div>
			<p className="line-clamp-1 whitespace-wrap break-all text-xs text-center">{fileName}</p>
		</div>
	);
}
